import { Analytics } from '@hai/ui-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import systemInfo, { updateSystemInfo } from 'src/js/data/systemInfo';

interface UserAnalyticsProps {
  handleAnalyticsClose: () => any;
}

export const UserAnalytics: React.FunctionComponent<UserAnalyticsProps> = (props: UserAnalyticsProps) => {
  const { t } = useTranslation();

  const handleAnalyticsChange = (accepted: boolean) => {
    updateSystemInfo({ ...systemInfo, analytics: accepted ? 'accepted' : 'declined' });
  };

  return (
    <Analytics
      {...{ zindex: 1055 }}
      show={true}
      onClose={props.handleAnalyticsClose}
      onChange={handleAnalyticsChange}
      type="modal"
      localeInfo={{
        modalMainText: t('userAnalytics.modalMainText'),
        modalMoreInformationText: t('userAnalytics.modalMoreInformationText'),
        modalContinueText: t('userAnalytics.modalContinueText'),
        modalDeclineText: t('userAnalytics.modalDeclineText'),
        modalTitle: t('userAnalytics.modalTitle'),
        privacyPolicyText: t('userAnalytics.privacyPolicyText'),
      }}
    />
  );
};
